import { render, staticRenderFns } from "./ContractDetailActivities.vue?vue&type=template&id=1f954a8e&"
import script from "./ContractDetailActivities.vue?vue&type=script&lang=js&"
export * from "./ContractDetailActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports